import { actionsCounterMaterial } from './actions';

const CounterMaterialReducer = {
    [actionsCounterMaterial.APPLY_COUNTER_MATERIAL]: (state, actionsCounterMaterial) => { return { ...state, counterMaterial: actionsCounterMaterial.counterMaterial } },
}

export default CounterMaterialReducer;